import { useState, useEffect } from 'react';
import { Eye } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const VisitorCounter = () => {
  const [visitorCount, setVisitorCount] = useState(null);

  useEffect(() => {
    const trackVisit = async () => {
      try {
        // Track this visit
        const response = await axios.post(`${BACKEND_URL}/api/visitors/track`);
        setVisitorCount(response.data.total_visitors);
      } catch (error) {
        // If tracking fails, try to get count
        try {
          const countResponse = await axios.get(`${BACKEND_URL}/api/visitors/count`);
          setVisitorCount(countResponse.data.total_visitors);
        } catch (e) {
          console.error('Failed to get visitor count');
        }
      }
    };

    trackVisit();
  }, []);

  if (visitorCount === null) return null;

  // Format number with commas
  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div 
      className="fixed bottom-4 right-4 z-40 bg-navy/90 backdrop-blur-sm text-white px-4 py-2 flex items-center gap-2 text-sm shadow-lg"
      data-testid="visitor-counter"
    >
      <Eye className="w-4 h-4 text-gold" />
      <span className="text-white/70">Visitors:</span>
      <span className="font-semibold text-gold">{formatNumber(visitorCount)}</span>
    </div>
  );
};

export default VisitorCounter;
